module.exports = __webpack_public_path__ + "img/news16_1.37e92edb.jpg";